import { EntityStore } from '../../../shared/stores/EntityStore';
import { action, makeObservable } from 'mobx';
import { api } from '../../../shared/api/api';

class ExpertiseAreaStore extends EntityStore {
	constructor() {
		super('expertise-areas');
		makeObservable(this);
	}

	@action
	async getExpertiseAreas(query) {
		const url = this.entityPluralEndpoint + '?q=' + query;
		const result = await api.get(encodeURI(url));
		return result;
	}
}

export const expertiseAreaStore = new ExpertiseAreaStore();
